export default __webpack_public_path__ + "locales/sl/SalesDepartmentRequestDialog.json?hash=5794ccc08bc090f0b9139f5db65365c8";